import React, { useState } from "react";
// react redux
import { useSelector } from "react-redux";
// react router /
import { useNavigate } from "react-router";
// react-hook-form
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// mui
import { Stack, FormControlLabel, Switch } from "@mui/material";
// axios
import EnhancedAxios from "../../axios/EnhancedAxios";
import { AxiosError, AxiosResponse } from "axios";
// componennts
import {
    PageTitle,
    SubmitButton,
    InputField,
    SelectCity,
} from "../../components";
// schema
import { addAreaSchema } from "../../schemes/area/addAreaSchema";
// types
import { ReduxUserReducerState } from "../../types/global";
// alerts
import { errorAlert, successAlert } from "../../utils/alerts/alerts";

// form values type
type FormValues = {
    name: string;
    city: {
        id: string;
    } | null;
    delivery_price: number;
    is_disabled: boolean;
};

const AddArea = () => {
    const navigate = useNavigate();
    const userToken = useSelector(
        (state: ReduxUserReducerState) => state.user.userToken
    );
    const [submitting, setSubmitting] = useState(false);
    // --------------------------- form handle ---------------------------
    const form = useForm<FormValues>({
        defaultValues: {
            name: "",
            city: null,
            delivery_price: 0,
            is_disabled: false,
        },
        resolver: yupResolver(addAreaSchema),
        mode: "all",
    });
    const {
        register,
        setValue,
        getValues,
        control,
        reset,
        watch,
        formState: { errors },
        handleSubmit,
    } = form;
    const onSubmit: SubmitHandler<FormValues> = (data) => {
        setSubmitting(true);
        const newData = { ...data, city: { id: data?.city?.id } };
        EnhancedAxios(null, userToken)
            .post(`/admin/areas`, newData)
            .then((res: AxiosResponse) => {
                successAlert(`تم اضافة مدينى باسم "${newData.name}" `);
                reset();
                setSubmitting(false);
                navigate(-1);
            })
            .catch((error: AxiosError) => {
                errorAlert(error);
                setSubmitting(false);
            });
    };
    return (
        <Stack gap="20px">
            <PageTitle title="اضافة منطقة" />
            <Stack alignItems="center">
                <Stack
                    width="100%"
                    maxWidth="800px"
                    gap="10px"
                    component="form"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <InputField
                        type="text"
                        registration={{ ...register("name") }}
                        label="اسم المنطقة"
                        errorMessage={errors?.name?.message}
                    />
                    <SelectCity
                        getValues={getValues}
                        setValue={setValue}
                        errorMessage={errors?.city?.message}
                        control={control}
                    />
                    <InputField
                        type="number"
                        registration={{ ...register("delivery_price") }}
                        label="تكلفة التوصيل"
                        errorMessage={errors?.delivery_price?.message}
                    />
                    <Controller
                        name="is_disabled"
                        control={control}
                        render={({ field }) => (
                            <FormControlLabel
                                control={
                                    <Switch
                                        {...field}
                                        checked={!watch("is_disabled")}
                                        onChange={(e) =>
                                            setValue(
                                                "is_disabled",
                                                !e.target.checked
                                            )
                                        }
                                    />
                                }
                                label="مفعل"
                            />
                        )}
                    />
                    <SubmitButton label="انشاء" disabled={submitting} />
                </Stack>
            </Stack>
        </Stack>
    );
};

export default AddArea;
